// src/onboarding/OnbGround.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).

import { useMemo } from 'react';

export default function OnbGround({ variant = "dawn", darkMode = false }) {
  const palette = darkMode
    ? ({
        dawn: { far: "#2d3a2d", near: "#1e2a1e", blade: "#3a5230" },
        day:  { far: "#324234", near: "#223020", blade: "#3a5230" },
        noon: { far: "#3a4c38", near: "#283828", blade: "#2d4226" },
      }[variant] || { far: "#2d3a2d", near: "#1e2a1e", blade: "#3a5230" })
    : ({
        dawn: { far: "#9ab48a", near: "#6b8a55", blade: "#5a7a4a" },
        day:  { far: "#a7c58f", near: "#78965b", blade: "#5a7a4a" },
        noon: { far: "#b6d49b", near: "#85a565", blade: "#4f7242" },
      }[variant] || { far: "#9ab48a", near: "#6b8a55", blade: "#5a7a4a" });

  const blades = useMemo(() => Array.from({ length: 28 }).map((_, i) => ({
    key: i,
    left: `${(i / 28) * 100 + (i % 3)}%`,
    height: 8 + (i % 5) * 3,
    delay: (i * 0.13) % 2,
  })), []);

  return (
    <div className="onb-ground" aria-hidden="true">
      <svg viewBox="0 0 402 350" preserveAspectRatio="none"
           style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}>
        <path d="M 0 120 C 60 80, 180 110, 260 95 S 402 70, 402 90 L 402 350 L 0 350 Z" fill={palette.far} opacity="0.55"/>
        <path d="M 0 180 C 80 150, 160 190, 240 170 S 402 150, 402 180 L 402 350 L 0 350 Z" fill={palette.near} opacity="0.75"/>
        <path d="M 0 260 L 402 240 L 402 350 L 0 350 Z" fill="#7a5a3d" opacity="0.28"/>
      </svg>
      {blades.map(b => (
        <div key={b.key} className="onb-blade" style={{
          left: b.left,
          height: b.height,
          animationDelay: `${b.delay}s`,
          "--blade-color": palette.blade,
        }}/>
      ))}
    </div>
  );
}
